(function () {
  var key = "cpc_escolha";
  var popup = document.querySelector("[data-cpc-profile]");
  var label = document.querySelector("[data-cpc-profile-label]");

  function readPerfil() {
    var match = document.cookie.match(/(?:^|; )cpc_escolha=([^;]+)/);
    if (match && (match[1] === "tecnico" || match[1] === "cliente")) return match[1];
    try {
      var stored = localStorage.getItem(key);
      if (stored === "tecnico" || stored === "cliente") return stored;
    } catch (error) {}
    return "";
  }

  function viewName() {
    return new URLSearchParams(window.location.search).get("view") || "";
  }

  function isClienteView() {
    return viewName() === "cliente";
  }

  function isCasaView() {
    var view = viewName();
    return view === "cliente" || view === "custo" || view === "durabilidade" || view === "dados";
  }

  function isHome() {
    var path = window.location.pathname.replace(/\/+$/, "");
    return path === "";
  }

  function save(perfil) {
    document.cookie = key + "=" + perfil + ";path=/;max-age=2592000;SameSite=Lax";
    try { localStorage.setItem(key, perfil); } catch (error) {}
    document.documentElement.setAttribute("data-cpc-perfil", perfil);
    document.documentElement.removeAttribute("data-cpc-ask");
  }

  function updateLabel(perfil) {
    document.querySelectorAll(".cpc-tabs [data-cpc-perfil]").forEach(function (tab) {
      var active = tab.getAttribute("data-cpc-perfil") === perfil || (!perfil && tab.getAttribute("data-cpc-perfil") === "tecnico" && !isClienteView());
      tab.setAttribute("aria-selected", active ? "true" : "false");
    });
    if (!label) return;
    if (perfil === "tecnico") label.textContent = "Perfil: técnico · Trocar";
    else if (perfil === "cliente") label.textContent = "Perfil: cliente final · Trocar";
    else label.textContent = "Escolher perfil";
  }

  function go(perfil, replace) {
    var current = new URLSearchParams(window.location.search);
    var url = new URL("/", window.location.origin);
    if (perfil === "cliente") url.searchParams.set("view", "cliente");
    var preview = current.get("preview_theme_id");
    if (preview) url.searchParams.set("preview_theme_id", preview);
    var path = window.location.pathname.replace(/\/+$/, "") || "/";
    var same = path === "/" && window.location.search === url.search && !window.location.hash;
    if (same) {
      if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
      window.scrollTo(0, 0);
      window.location.reload();
      return;
    }
    if (replace) window.location.replace(url.toString());
    else window.location.assign(url.toString());
  }

  function openPopup() {
    if (!popup) return;
    popup.classList.add("is-open");
    var first = popup.querySelector("[data-cpc-perfil]");
    if (first) first.focus();
  }

  function closePopup() {
    if (popup) popup.classList.remove("is-open");
  }

  function choose(perfil) {
    save(perfil);
    updateLabel(perfil);
    go(perfil, false);
  }

  var perfil = readPerfil();
  updateLabel(perfil);

  if (!perfil && isHome() && !isCasaView()) {
    document.documentElement.setAttribute("data-cpc-ask", "1");
    openPopup();
  } else if (isHome() && perfil === "cliente" && !isCasaView()) {
    go("cliente", true);
  } else if (isClienteView() && perfil === "tecnico") {
    go("tecnico", true);
  }

  document.addEventListener("click", function (event) {
    var tab = event.target.closest(".cpc-tabs [data-cpc-perfil]");
    if (tab) {
      event.preventDefault();
      choose(tab.getAttribute("data-cpc-perfil"));
      return;
    }
    if (event.target.closest("[data-cpc-profile-open]")) {
      openPopup();
      return;
    }
    if (event.target.closest("[data-cpc-profile-close]")) {
      if (!readPerfil()) save(isClienteView() ? "cliente" : "tecnico");
      closePopup();
      return;
    }
    var choice = event.target.closest("[data-cpc-perfil]");
    if (choice && popup && popup.contains(choice)) {
      choose(choice.getAttribute("data-cpc-perfil"));
    }
  });

  function casaHref(href) {
    if (readPerfil() !== "cliente" && !isClienteView()) return href;
    try {
      var next = new URL(href, window.location.origin);
      if (next.origin !== window.location.origin) return href;
      var path = next.pathname;
      if (path.indexOf("/collections/") !== 0 && path.indexOf("/products/") !== 0) return href;
      next.searchParams.set("view", "cliente");
      return next.pathname + next.search + next.hash;
    } catch (error) {
      return href;
    }
  }

  function stampCasaLinks(root) {
    (root || document).querySelectorAll(".list-vertical_menu a[href], .vertical_menu a[href]").forEach(function (link) {
      var href = link.getAttribute("href");
      if (!href || href.indexOf("javascript:") === 0) return;
      var next = casaHref(href);
      if (next !== href) link.setAttribute("href", next);
    });
  }

  function pinDepartamentos() {
    document.querySelectorAll(".vertical_menu").forEach(function (menu) {
      var list = menu.querySelector(".list-vertical_menu");
      var title = menu.querySelector(".title_vertical_menu");
      if (!list || !title) return;
      if (!menu.classList.contains("active")) {
        if (list.getAttribute("data-cpc-pinned")) {
          list.removeAttribute("style");
          list.removeAttribute("data-cpc-pinned");
        }
        return;
      }
      var box = title.getBoundingClientRect();
      list.setAttribute("data-cpc-pinned", "1");
      list.style.transition = "none";
      list.style.transform = "none";
      list.style.position = "fixed";
      list.style.top = Math.round(box.bottom) + "px";
      list.style.left = Math.round(box.left) + "px";
      list.style.width = "280px";
      list.style.minWidth = "280px";
      list.style.right = "auto";
      list.style.zIndex = "10070";
      list.style.opacity = "1";
      list.style.pointerEvents = "auto";
      list.style.overflow = "visible";
      stampCasaLinks(list);
    });
  }

  document.addEventListener("click", function () {
    window.setTimeout(pinDepartamentos, 40);
  });
  window.addEventListener("scroll", function () {
    if (document.querySelector(".vertical_menu.active")) pinDepartamentos();
  }, true);
  window.addEventListener("resize", pinDepartamentos);
  if (window.MutationObserver) {
    var menuList = document.querySelector(".list-vertical_menu");
    if (menuList) {
      new MutationObserver(function () { stampCasaLinks(menuList); }).observe(menuList, { childList: true, subtree: true });
    }
  }
  stampCasaLinks(document);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && popup && popup.classList.contains("is-open")) {
      if (!readPerfil()) save(isClienteView() ? "cliente" : "tecnico");
      closePopup();
    }
  });

  var promo = document.querySelector("[data-cpc-promo]");
  if (promo) {
    var slides = promo.querySelectorAll("a");
    var promoIndex = 0;
    if (slides.length > 1) {
      setInterval(function () {
        slides[promoIndex].classList.remove("is-active");
        promoIndex = (promoIndex + 1) % slides.length;
        slides[promoIndex].classList.add("is-active");
      }, 5000);
    }
  }

  document.querySelectorAll("[data-cpc-rail]").forEach(function (rail) {
    var track = rail.querySelector(".cpc-casa__grid");
    if (!track || track.children.length < 2) return;
    var timer = null;
    var moving = false;
    var wide = window.matchMedia("(min-width: 981px)");

    var prev = document.createElement("button");
    var next = document.createElement("button");
    prev.type = "button";
    next.type = "button";
    prev.className = "cpc-casa__arrow cpc-casa__arrow--prev";
    next.className = "cpc-casa__arrow cpc-casa__arrow--next";
    prev.setAttribute("aria-label", "Cabos anteriores");
    next.setAttribute("aria-label", "Próximos cabos");
    prev.innerHTML = "<span aria-hidden=\"true\">&#8249;</span>";
    next.innerHTML = "<span aria-hidden=\"true\">&#8250;</span>";
    rail.appendChild(prev);
    rail.appendChild(next);

    function resetTrack() {
      moving = false;
      track.style.transition = "none";
      track.style.transform = "none";
    }

    function cardShift() {
      var card = track.firstElementChild;
      if (!card) return 0;
      return card.getBoundingClientRect().width + 14;
    }

    function goNext() {
      if (!wide.matches) {
        var max = rail.scrollWidth - rail.clientWidth;
        if (rail.scrollLeft >= max - 8) rail.scrollTo({ left: 0, behavior: "smooth" });
        else rail.scrollBy({ left: cardShift(), behavior: "smooth" });
        return;
      }
      if (moving) return;
      var card = track.firstElementChild;
      var shift = cardShift();
      if (!card || !shift) return;
      moving = true;
      track.style.transition = "transform 0.45s ease";
      track.style.transform = "translateX(" + (-shift) + "px)";
      track.addEventListener("transitionend", function done() {
        track.removeEventListener("transitionend", done);
        track.style.transition = "none";
        track.appendChild(card);
        track.style.transform = "translateX(0)";
        moving = false;
      });
    }

    function goPrev() {
      if (!wide.matches) {
        if (rail.scrollLeft <= 8) rail.scrollTo({ left: rail.scrollWidth, behavior: "smooth" });
        else rail.scrollBy({ left: -cardShift(), behavior: "smooth" });
        return;
      }
      if (moving) return;
      var card = track.lastElementChild;
      var shift = cardShift();
      if (!card || !shift) return;
      moving = true;
      track.style.transition = "none";
      track.insertBefore(card, track.firstElementChild);
      track.style.transform = "translateX(" + (-shift) + "px)";
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          track.style.transition = "transform 0.45s ease";
          track.style.transform = "translateX(0)";
          track.addEventListener("transitionend", function done() {
            track.removeEventListener("transitionend", done);
            moving = false;
          });
        });
      });
    }

    function play() {
      if (!wide.matches || timer) return;
      timer = setInterval(goNext, 3000);
    }

    function pause() {
      clearInterval(timer);
      timer = null;
    }

    function sync() {
      if (wide.matches) {
        play();
      } else {
        pause();
        resetTrack();
      }
    }

    prev.addEventListener("click", function () {
      pause();
      goPrev();
    });
    next.addEventListener("click", function () {
      pause();
      goNext();
    });
    rail.addEventListener("mouseenter", pause);
    rail.addEventListener("mouseleave", play);
    if (wide.addEventListener) wide.addEventListener("change", sync);
    else if (wide.addListener) wide.addListener(sync);
    sync();
  });

  var quiz = document.querySelector("[data-cpc-quiz]");
  if (quiz) {
    var quizPanel = quiz.querySelector("[data-cpc-quiz-panel]");
    var quizProducts = {};
    try {
      quizProducts = JSON.parse(quiz.querySelector("[data-cpc-quiz-products]").textContent);
    } catch (error) {}
    var quizState = { uso: "", distancia: "" };
    var quizStep = "uso";
    var quizSizes = {
      curto: { nome: "Cabo curto, de 50 cm", alcance: "Serve quando o aparelho e o roteador ficam quase encostados, na mesma mesa." },
      m1: { nome: "Cabo de 1 metro", alcance: "Serve para atravessar uma mesa ou ir de um móvel até o outro, sem esticar." },
      m25: { nome: "Cabo de 2,5 metros", alcance: "Serve no mesmo cômodo, quando o roteador fica mais longe do aparelho." },
      m3: { nome: "Cabo de 3 metros", alcance: "Serve para alcançar outro ponto da casa, ainda sem um fio enorme sobrando." }
    };

    function quizEsc(value) {
      return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
      });
    }

    function quizChoice(value, label, text) {
      return '<button type="button" class="cpc-quiz__choice" data-cpc-quiz-value="' + quizEsc(value) + '"><strong>' + quizEsc(label) + '</strong><span>' + quizEsc(text) + '</span></button>';
    }

    function quizSizeKey() {
      if (quizState.distancia === "curto") return "curto";
      if (quizState.distancia === "1") return "m1";
      if (quizState.distancia === "medio") return "m25";
      return "m3";
    }

    function quizWhy() {
      var size = quizSizes[quizSizeKey()];
      var uso = quizState.uso === "jogo"
        ? "No videogame, o cabo de rede segura a partida melhor do que o Wi-Fi: menos travada e mais velocidade."
        : quizState.uso === "notebook"
          ? "No notebook, o cabo de rede deixa a internet firme na mesa, sem depender do Wi-Fi."
          : "No computador, o cabo de rede liga direto no roteador. A internet fica firme o tempo todo.";
      return uso + " " + size.alcance;
    }

    function quizMore() {
      return { href: "#tipos", label: "Ver os tipos" };
    }

    function quizSteps(current) {
      return '<div class="cpc-quiz__steps" aria-hidden="true"><span class="is-on"></span><span class="' + (current > 1 ? "is-on" : "") + '"></span><span class="' + (current > 2 ? "is-on" : "") + '"></span></div>';
    }

    function quizRender() {
      if (quizStep === "uso") {
        quizPanel.innerHTML =
          quizSteps(1) +
          '<p class="cpc-quiz__count">Pergunta 1 de 2</p>' +
          '<h3 class="cpc-quiz__question">O cabo de rede vai em qual aparelho?</h3>' +
          '<div class="cpc-quiz__choices">' +
            quizChoice("computador", "Computador", "Para usar a internet direto no roteador.") +
            quizChoice("notebook", "Notebook", "Para a internet ficar firme na mesa.") +
            quizChoice("jogo", "Videogame", "Para jogar com menos travada do que no Wi-Fi.") +
          "</div>";
        return;
      }
      if (quizStep === "distancia") {
        quizPanel.innerHTML =
          quizSteps(2) +
          '<p class="cpc-quiz__count">Pergunta 2 de 2</p>' +
          '<h3 class="cpc-quiz__question">Onde fica o roteador, olhando desse aparelho?</h3>' +
          '<div class="cpc-quiz__choices">' +
            quizChoice("curto", "Na mesma mesa, quase encostado", "Dá para ligar sem o cabo cair no chão.") +
            quizChoice("1", "Do outro lado da mesa", "Um passo de distância, ainda no mesmo móvel.") +
            quizChoice("medio", "No mesmo cômodo, mais longe", "O roteador está no quarto, mas não do lado.") +
            quizChoice("longe", "Em outro ponto da casa", "Precisa alcançar mais, sem um rolo enorme.") +
          "</div>" +
          '<button type="button" class="cpc-quiz__back" data-cpc-quiz-back>Voltar</button>';
        return;
      }
      var key = quizSizeKey();
      var size = quizSizes[key];
      var product = quizProducts[key];
      var more = quizMore();
      var card = product
        ? '<a class="cpc-quiz__result" href="' + quizEsc(product.url) + '">' +
            (product.image ? '<img src="' + quizEsc(product.image) + '" alt="">' : "") +
            "<span><small>" + quizEsc(size.nome) + "</small><strong>" + quizEsc(product.title) + "</strong><em>" + quizEsc(product.price) + "</em></span></a>"
        : "";
      quizPanel.innerHTML =
        quizSteps(3) +
        '<p class="cpc-quiz__count">Seu cabo de rede</p>' +
        '<h3 class="cpc-quiz__question">' + quizEsc(size.nome) + "</h3>" +
        '<p class="cpc-quiz__why">' + quizEsc(quizWhy()) + "</p>" +
        card +
        '<div class="cpc-quiz__actions">' +
          (product ? '<a class="cpc-casa__btn cpc-casa__btn--dark" href="' + quizEsc(product.url) + '">Quero este cabo</a>' : "") +
          '<a class="cpc-casa__btn cpc-casa__btn--line" href="' + quizEsc(more.href) + '">' + quizEsc(more.label) + "</a>" +
          '<button type="button" class="cpc-quiz__back" data-cpc-quiz-restart>Responder de novo</button>' +
        "</div>";
    }

    quiz.addEventListener("click", function (event) {
      var choice = event.target.closest("[data-cpc-quiz-value]");
      if (choice) {
        var value = choice.getAttribute("data-cpc-quiz-value");
        if (quizStep === "uso") {
          quizState.uso = value;
          quizState.distancia = "";
          quizStep = "distancia";
        } else if (quizStep === "distancia") {
          quizState.distancia = value;
          quizStep = "resultado";
        }
        quizRender();
        return;
      }
      if (event.target.closest("[data-cpc-quiz-back]")) {
        quizStep = "uso";
        quizRender();
        return;
      }
      if (event.target.closest("[data-cpc-quiz-restart]")) {
        quizState.uso = "";
        quizState.distancia = "";
        quizStep = "uso";
        quizRender();
      }
    });

    quizRender();
  }

  function initCasaQuiz(root) {
    var tela = root.querySelector("[data-cpc-tela]");
    var panel = tela.querySelector("[data-cpc-tela-panel]");
    var products = {};
    try {
      products = JSON.parse(tela.querySelector("[data-cpc-tela-products]").textContent);
    } catch (error) {}
    var state = {};
    var step = "aparelho";
    var names = {
      curto: "Cat6 de 50 cm, 100% cobre",
      m1: "Cat6 de 1 metro, 100% cobre",
      m1cca: "Cat6 de 1 metro, opção mais em conta",
      m25: "Cat6 de 2,5 metros",
      m3cca: "Cat6 de 3 metros",
      m5: "Cat6 de 5 metros, 100% cobre",
      m5cca: "Cat6 de 5 metros, opção mais em conta",
      c5curto: "Cat5e de 50 cm, 100% cobre",
      c5m1: "Cat5e de 1 metro, 100% cobre",
      c5m1cca: "Cat5e de 1 metro, opção mais em conta",
      c5m25: "Cat5e de 2,5 metros",
      c5m3cca: "Cat5e de 3 metros",
      c5m5: "Cat5e de 5 metros, 100% cobre",
      c5m5cca: "Cat5e de 5 metros, opção mais em conta",
      blindado: "Cabo com proteção contra interferência",
      hdmiCurto: "HDMI curto",
      hdmiMedio: "HDMI de cerca de 2 metros",
      hdmiLongo: "HDMI mais longo",
      hdmi4k: "HDMI para videogame e 4K",
      hdmi90: "HDMI com plugue que dobra",
      forca: "Cabo de força",
      extensao: "Extensão",
      filtro: "Extensão para vários aparelhos"
    };
    var perguntas = {
      aparelho: ["Qual aparelho vai na internet?", [
        ["computador", "Computador", "Fica ligado direto no roteador."],
        ["notebook", "Notebook", "Internet firme na mesa."],
        ["videogame", "Videogame", "Menos travada do que no Wi-Fi."],
        ["tv", "TV", "Filme e série sem ficar carregando."]
      ]],
      velocidade: ["Qual é a velocidade da sua internet?", [
        ["ate100", "Até 100 mega", "O Cat5e é o ideal para essa velocidade."],
        ["ate500", "De 100 a 500 mega", "O Cat5e continua sendo o ideal."],
        ["ate1", "De 500 mega a 1 giga", "O Cat5e alcança até 1 giga."],
        ["acima", "Mais de 1 giga", "Aqui o ideal é o Cat6."]
      ]],
      distancia: ["Onde fica o roteador?", [
        ["curto", "Quase encostado", "Até 50 cm, na mesma mesa."],
        ["mesa", "Do outro lado da mesa", "Cerca de 1 metro."],
        ["comodo", "No mesmo cômodo", "Até uns 2,5 metros."],
        ["longe", "Mais longe", "De 3 a 5 metros, em outro ponto da casa."]
      ]],
      fio: ["O cabo passa perto de fio de energia?", [
        ["nao", "Não", "O caminho fica longe de tomada e motor."],
        ["sim", "Sim", "Passa junto de fio elétrico ou muita fiação."]
      ]],
      prioridade: ["O que importa mais neste cabo?", [
        ["durar", "Durar mais", "Fio 100% cobre."],
        ["economia", "Gastar menos", "A opção mais em conta para essa distância."]
      ]]
    };

    function esc(value) {
      return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
      });
    }

    function choice(value, label, text) {
      return '<button type="button" class="cpc-quiz__choice" data-cpc-tela-value="' + esc(value) + '"><strong>' + esc(label) + '</strong><span>' + esc(text) + '</span></button>';
    }

    function path() {
      var list = ["aparelho", "velocidade", "distancia", "fio"];
      if (state.fio !== "sim") list.push("prioridade");
      return list;
    }

    function bars(current, total) {
      var html = '<div class="cpc-quiz__steps" aria-hidden="true">';
      for (var i = 1; i <= total; i++) html += '<span class="' + (i <= current ? "is-on" : "") + '"></span>';
      return html + "</div>";
    }

    function resultKey() {
      if (state.fio === "sim") return "blindado";
      var cat5 = state.velocidade !== "acima";
      var economia = state.prioridade === "economia";
      if (state.distancia === "curto") return cat5 ? "c5curto" : "curto";
      if (state.distancia === "mesa") return cat5 ? (economia ? "c5m1cca" : "c5m1") : (economia ? "m1cca" : "m1");
      if (state.distancia === "comodo") return cat5 ? (economia ? "c5m3cca" : "c5m25") : (economia ? "m3cca" : "m25");
      return cat5 ? (economia ? "c5m5cca" : "c5m5") : (economia ? "m5cca" : "m5");
    }

    function family() {
      return state.velocidade === "acima" ? "rede" : "cat5e";
    }

    function why(key) {
      var aparelho = state.aparelho === "videogame"
        ? "No videogame, o cabo segura a partida melhor do que o Wi-Fi."
        : state.aparelho === "notebook"
          ? "No notebook, o cabo deixa a internet firme na mesa."
          : state.aparelho === "tv"
            ? "Na TV, o cabo liga direto no roteador e o filme trava menos."
            : "No computador, o cabo liga direto no roteador e a internet fica firme.";
      var extra = key === "blindado"
        ? " Como o caminho passa perto de fio de energia, este cabo tem proteção contra interferência."
        : key.indexOf("curto") !== -1
          ? " Meio metro alcança quando o aparelho está quase encostado no roteador."
          : key.indexOf("m1") !== -1
            ? " Um metro atravessa a mesa."
            : key.indexOf("m25") !== -1 || key.indexOf("m3") !== -1
              ? " Esse comprimento cruza o mesmo cômodo."
              : " Cinco metros alcançam outro ponto da casa.";
      if (key === "blindado" && state.velocidade !== "acima") extra += " Mesmo nessa velocidade, perto da energia este cabo com proteção é o indicado.";
      else if (state.velocidade === "ate100") extra += " Até 100 mega, o Cat5e é o ideal.";
      else if (state.velocidade === "ate500") extra += " De 100 a 500 mega, o Cat5e é o ideal.";
      else if (state.velocidade === "ate1") extra += " De 500 mega a 1 giga, o Cat5e alcança essa velocidade.";
      else if (state.velocidade === "acima") extra += " Acima de 1 giga, o Cat6 é o ideal.";
      if (state.prioridade === "economia" && state.fio !== "sim") extra += " Esta é a opção mais em conta nesse tamanho.";
      if (state.prioridade === "durar" && state.fio !== "sim" && key.indexOf("cca") === -1) extra += " O fio é 100% cobre.";
      return aparelho + extra;
    }

    function render() {
      if (perguntas[step]) {
        var list = path();
        var index = list.indexOf(step) + 1;
        var total = list.length;
        var count = "Pergunta " + index + " de " + total;
        var opcoes = perguntas[step][1].map(function (item) {
          return choice(item[0], item[1], item[2]);
        }).join("");
        panel.innerHTML =
          bars(index, Math.max(total, index)) +
          '<p class="cpc-quiz__count">' + count + "</p>" +
          '<h3 class="cpc-quiz__question">' + esc(perguntas[step][0]) + "</h3>" +
          '<div class="cpc-quiz__choices">' + opcoes + "</div>" +
          (step === "aparelho" ? "" : '<button type="button" class="cpc-quiz__back" data-cpc-tela-back>Voltar</button>');
        return;
      }
      var key = resultKey();
      var list = path();
      var product = products[key];
      var hasProduct = product && product.title;
      var href = hasProduct ? product.url : ((products.colecoes && products.colecoes[family()]) || "/collections/all?view=cliente");
      var card = hasProduct
        ? '<a class="cpc-quiz__result" href="' + esc(href) + '">' +
            (product.image ? '<img src="' + esc(product.image) + '" alt="">' : "") +
            "<span><small>" + esc(names[key] || "Cabo indicado") + "</small><strong>" + esc(product.title) + "</strong><em>" + esc(product.price) + "</em></span></a>"
        : "";
      panel.innerHTML =
        bars(list.length, list.length) +
        '<p class="cpc-quiz__count">Cabo indicado</p>' +
        '<h3 class="cpc-quiz__question">' + esc(names[key] || "Cabo indicado") + "</h3>" +
        '<p class="cpc-quiz__why">' + esc(why(key)) + "</p>" +
        card +
        '<div class="cpc-quiz__actions">' +
          '<a class="cpc-casa__btn cpc-casa__btn--dark" href="' + esc(href) + '">' + (hasProduct ? "Quero este cabo" : "Ver cabos dessa medida") + "</a>" +
          '<button type="button" class="cpc-quiz__back" data-cpc-tela-back>Voltar</button>' +
          '<button type="button" class="cpc-quiz__back" data-cpc-tela-restart>Responder de novo</button>' +
        "</div>";
    }

    function openTela() {
      tela.hidden = false;
      document.body.style.overflow = "hidden";
      render();
    }

    function closeTela() {
      tela.hidden = true;
      document.body.style.overflow = "";
    }

    function beginTela() {
      state = {};
      step = "aparelho";
      openTela();
    }

    root.addEventListener("click", function (event) {
      if (event.target.closest("[data-cpc-tela-open]")) beginTela();
      else if (event.target.closest("[data-cpc-tela-close]")) closeTela();
    });

    document.addEventListener("click", function (event) {
      var opener = event.target.closest("[data-cpc-tela-open]");
      if (!opener || root.contains(opener) || opener.closest("[data-cpc-tela-root]")) return;
      beginTela();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !tela.hidden) closeTela();
    });

    tela.addEventListener("click", function (event) {
      var picked = event.target.closest("[data-cpc-tela-value]");
      if (picked) {
        state[step] = picked.getAttribute("data-cpc-tela-value");
        var list = path();
        var next = list[list.indexOf(step) + 1];
        step = next || "resultado";
        render();
        return;
      }
      if (event.target.closest("[data-cpc-tela-back]")) {
        if (step === "resultado") {
          var list = path();
          step = list[list.length - 1];
        } else {
          var listBack = path();
          var index = listBack.indexOf(step);
          state[step] = "";
          step = index > 0 ? listBack[index - 1] : "aparelho";
        }
        render();
        return;
      }
      if (event.target.closest("[data-cpc-tela-restart]")) beginTela();
    });
  }

  document.querySelectorAll("[data-cpc-tela-root]").forEach(function (root) {
    if (root.hasAttribute("data-cpc-quiz-casa")) {
      initCasaQuiz(root);
      return;
    }
    var tela = root.querySelector("[data-cpc-tela]");
    var panel = tela.querySelector("[data-cpc-tela-panel]");
    var products = {};
    try {
      products = JSON.parse(tela.querySelector("[data-cpc-tela-products]").textContent);
    } catch (error) {}
    var state = { uso: "", distancia: "", energia: "" };
    var step = "uso";
    var names = {
      perto: "Cabo de 1 metro",
      medio: "Cabo de 2,5 metros",
      longe: "Cabo de 5 metros",
      energia: "Cabo com proteção extra"
    };

    function esc(value) {
      return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
      });
    }

    function choice(value, label, text) {
      return '<button type="button" class="cpc-quiz__choice" data-cpc-tela-value="' + esc(value) + '"><strong>' + esc(label) + '</strong><span>' + esc(text) + '</span></button>';
    }

    function steps(current) {
      return '<div class="cpc-quiz__steps" aria-hidden="true"><span class="is-on"></span><span class="' + (current > 1 ? "is-on" : "") + '"></span><span class="' + (current > 2 ? "is-on" : "") + '"></span></div>';
    }

    function resultKey() {
      if (state.energia === "sim") return "energia";
      if (state.distancia === "longe") return "longe";
      if (state.distancia === "medio") return "medio";
      return "perto";
    }

    function why(key) {
      var uso = state.uso === "jogo"
        ? "Para jogar, o cabo segura a partida melhor do que o Wi-Fi."
        : state.uso === "varios"
          ? "Para ligar mais de um aparelho, o cabo deixa cada ponto com internet firme."
          : "Para o computador, o cabo liga direto e a internet fica estável.";
      var extra = key === "energia"
        ? " Como o caminho passa perto de fio de energia, este cabo tem uma proteção a mais contra interferência."
        : key === "longe"
          ? " A distância pede um cabo de 5 metros, sem ficar curto no meio do caminho."
          : key === "medio"
            ? " Dá para cruzar a mesa ou o mesmo cômodo sem um rolo sobrando."
            : " Um metro alcança quando o aparelho fica perto do roteador.";
      return uso + extra;
    }

    function render() {
      if (step === "uso") {
        panel.innerHTML =
          steps(1) +
          '<p class="cpc-quiz__count">Pergunta 1 de 3</p>' +
          '<h3 class="cpc-quiz__question">O cabo vai servir para quê?</h3>' +
          '<div class="cpc-quiz__choices">' +
            choice("computador", "Computador", "Internet firme, ligada no roteador.") +
            choice("jogo", "Jogo", "Menos travada do que no Wi-Fi.") +
            choice("varios", "Vários aparelhos", "Mais de um ponto na mesma rede.") +
          "</div>";
        return;
      }
      if (step === "distancia") {
        panel.innerHTML =
          steps(2) +
          '<p class="cpc-quiz__count">Pergunta 2 de 3</p>' +
          '<h3 class="cpc-quiz__question">Qual a distância até o roteador?</h3>' +
          '<div class="cpc-quiz__choices">' +
            choice("perto", "Até 1 metro", "O aparelho fica ao lado.") +
            choice("medio", "Até 3 metros", "Dá para atravessar a mesa ou o móvel.") +
            choice("longe", "5 metros ou mais", "O roteador fica mais longe.") +
          "</div>" +
          '<button type="button" class="cpc-quiz__back" data-cpc-tela-back>Voltar</button>';
        return;
      }
      if (step === "energia") {
        panel.innerHTML =
          steps(3) +
          '<p class="cpc-quiz__count">Pergunta 3 de 3</p>' +
          '<h3 class="cpc-quiz__question">O cabo passa perto de fio de energia?</h3>' +
          '<div class="cpc-quiz__choices">' +
            choice("nao", "Não", "O caminho fica longe de tomada e motor.") +
            choice("sim", "Sim", "Passa junto de fio elétrico ou muita fiação.") +
          "</div>" +
          '<button type="button" class="cpc-quiz__back" data-cpc-tela-back>Voltar</button>';
        return;
      }
      var key = resultKey();
      var product = products[key];
      var card = product && product.title
        ? '<a class="cpc-quiz__result" href="' + esc(product.url) + '">' +
            (product.image ? '<img src="' + esc(product.image) + '" alt="">' : "") +
            "<span><small>" + esc(names[key]) + "</small><strong>" + esc(product.title) + "</strong><em>" + esc(product.price) + "</em></span></a>"
        : "";
      panel.innerHTML =
        steps(3) +
        '<p class="cpc-quiz__count">Cabo indicado</p>' +
        '<h3 class="cpc-quiz__question">' + esc(names[key]) + "</h3>" +
        '<p class="cpc-quiz__why">' + esc(why(key)) + "</p>" +
        card +
        '<div class="cpc-quiz__actions">' +
          (product && product.url ? '<a class="cpc-casa__btn cpc-casa__btn--dark" href="' + esc(product.url) + '">Quero este cabo</a>' : "") +
          '<button type="button" class="cpc-quiz__back" data-cpc-tela-restart>Responder de novo</button>' +
        "</div>";
    }

    function openTela() {
      tela.hidden = false;
      document.body.style.overflow = "hidden";
      render();
    }

    function closeTela() {
      tela.hidden = true;
      document.body.style.overflow = "";
    }

    function beginTela() {
      state = { uso: "", distancia: "", energia: "" };
      step = "uso";
      openTela();
    }

    root.addEventListener("click", function (event) {
      if (event.target.closest("[data-cpc-tela-open]")) {
        beginTela();
        return;
      }
      if (event.target.closest("[data-cpc-tela-close]")) {
        closeTela();
      }
    });

    document.addEventListener("click", function (event) {
      var opener = event.target.closest("[data-cpc-tela-open]");
      if (!opener || root.contains(opener) || opener.closest("[data-cpc-tela-root]")) return;
      beginTela();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !tela.hidden) closeTela();
    });

    tela.addEventListener("click", function (event) {
      var picked = event.target.closest("[data-cpc-tela-value]");
      if (picked) {
        var value = picked.getAttribute("data-cpc-tela-value");
        if (step === "uso") {
          state.uso = value;
          step = "distancia";
        } else if (step === "distancia") {
          state.distancia = value;
          step = "energia";
        } else if (step === "energia") {
          state.energia = value;
          step = "resultado";
        }
        render();
        return;
      }
      if (event.target.closest("[data-cpc-tela-back]")) {
        step = step === "energia" ? "distancia" : "uso";
        render();
        return;
      }
      if (event.target.closest("[data-cpc-tela-restart]")) {
        state = { uso: "", distancia: "", energia: "" };
        step = "uso";
        render();
      }
    });
  });
})();
